import { render } from "./PartialCard.vue?vue&type=template&id=0d747158"
import script from "./PartialCard.vue?vue&type=script&lang=js"
export * from "./PartialCard.vue?vue&type=script&lang=js"

import "./PartialCard.vue?vue&type=style&index=0&id=0d747158&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__